
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { useTournamentLeaderboardMedal } from '@/modules/tournament/leaderboard/model/medal';
import { ROUTE_NAME_TOURNAMENT } from '@/modules/tournament/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.MEDAL,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { model, list, total, fetchList, actions } = useTournamentLeaderboardMedal();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Rank', key: 'rank' },
                { type: TableColumnType.Image, label: 'Image', imageKey: 'image', statusKey: 'imageStatus' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-link',
                        theme: 'info',
                        tooltip: 'Link',
                        onclick: () => actions.link(row.id)
                    }),
                    canShow: (row: any) => !row.linkedLeaderboard
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-unlink',
                        theme: 'warning',
                        tooltip: 'Unlink',
                        onclick: () => actions.unlink(row.id)
                    }),
                    canShow: (row: any) => row.linkedLeaderboard
                }
            ]
        };

        onMounted(fetchList);

        return { table, model, list, total, fetch, actions };
    }
});
